import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MediaService {

  // Flags & icons are still Cloudinary-served through this service (out of scope of the
  // Image/disk-agnostic migration). General image URL construction now lives in ImageUrlService.

  _cloudinary_base_url = "https://res.cloudinary.com/cebt/image/upload/";
  _vimeo_thumbnail_base_url = "https://vumnail.com/";
  _fallback_avatar_url = 'https://res.cloudinary.com/cebt/image/upload/v1616972586/users/avatars/default-avatar.gif';
  _fallback_flag_round_url = 'https://res.cloudinary.com/cebt/image/upload/v1695749181/flags/round/missing.png';
  _fallback_scene_file_name = 'scenes/banners/rikuwolf_photo-realistic_colourful_crowd_of_diverse_people_happ_394e86a5-012f-4483-b532-344ab3caeb30_ozyvsl';
  cloudinary_flags_folder_path = "flags/";
  cloudinary_icons_folder_path = "icons/";

  constructor() { }

  get fallback_avatar_url (){
    return this._fallback_avatar_url;
  }
  get fallback_flag_round_url (){
    return this._fallback_flag_round_url;
  }
  get fallback_scene_file_name (){
    return this._fallback_scene_file_name;
  }
  get fallback_scene_url (){
    return this._cloudinary_base_url + this._fallback_scene_file_name + '.jpg';
  }
  get cloudinary_base_url (){
    return this._cloudinary_base_url;
  }

  getFlagUrlFromHash( hash:string, transformations:string, round:boolean, file_extension: string = null){

    // good transformations for flags: 'w_32,c_fill,ar_1:1,r_max/'

    if (!hash){
      hash = 'missing';
      round = true;
    }

    file_extension = file_extension ?? '.png';

    let path = round ?  this.cloudinary_flags_folder_path + 'round/' : this.cloudinary_flags_folder_path;

    return this.cloudinary_base_url + transformations + path + hash + file_extension;
  }
  getIconUrlFromIconIdentifier2( identifier_2 : string = 'icons/information', transformations:string = '', file_extension: string = '.png'){

    // good transformations for flags: 'w_32,c_fill,ar_1:1,r_max/'

    return this.cloudinary_base_url + transformations + identifier_2 + file_extension;
  }

}
